import React from "react";
import Form from "src/components/forms/TaskForm/Form";
import AddressForm from "src/components/forms/TaskForm/steps/AddressForm";
import InterviewForm from "src/components/forms/TaskForm/steps/InterviewForm";
import StudentPoolForm from "src/components/forms/TaskForm/steps/StudentPoolForm";
import VisibilityForm from "src/components/forms/TaskForm/steps/VisibilityForm";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Accordion from "src/components/layout/Accordion";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useModules from "src/hooks/selectors/useModules";

interface ExtraFormProps extends Translation {
	hideButtons?: boolean;
}

const ExtraForm = ({ t, hideButtons }: ExtraFormProps) => {
	const { actions, current } = useTaskForm();
	const { modules } = useModules();
	return (
		<Form
			value={{}}
			{...{ hideButtons }}
			onSubmit={async () => {
				actions.updateCurrent(current + 1);
			}}
		>
			{() => (
				<>
					{modules.includes("student-pool") && (
						<Accordion
							head={{
								title: t("accordions.invite"),
								variant: "sticky",
							}}
						>
							<StudentPoolForm hideButtons />
						</Accordion>
					)}

					<Accordion
						head={{
							title: t("accordions.visibility"),
							variant: "sticky",
						}}
					>
						<VisibilityForm hideButtons />
					</Accordion>
					<Accordion
						head={{
							title: t("accordions.address"),
							variant: "sticky",
						}}
					>
						<AddressForm hideButtons />
					</Accordion>
					<Accordion
						head={{
							title: t("accordions.interview"),
							variant: "sticky",
						}}
					>
						<InterviewForm hideButtons />
					</Accordion>
				</>
			)}
		</Form>
	);
};

ExtraForm.locale = {
	nl: {
		accordions: {
			invite: "Connecties uitnodigen",
			visibility: "Zichtbaarheid",
			address: "Locatie",
			interview: "Interview",
		},
	},
	en: {
		accordions: {
			invite: "Invite connections",
			visibility: "Visibility",
			address: "Location",
			interview: "Interview",
		},
	},
};

export default withTranslation(ExtraForm);
